import React from 'react';

export default function PhoneInput({ 
  value, 
  onChange, 
  placeholder = "8-digit local number", 
  required = false 
}) {
  // Extract local part, removing +852 or any non-digits
  const localPart = (value || '').replace(/\+852\s*/g, '').replace(/\D/g, '');

  const handleChange = (e) => {
    const raw = e.target.value.replace(/\D/g, '').slice(0, 8); // Max 8 digits
    
    // Pass back the formatted value to parent
    if (raw) {
      onChange(`+852 ${raw}`);
    } else {
      onChange('');
    }
  };

  return (
    <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
      <span style={{ 
        position: 'absolute', 
        left: 14, 
        color: 'var(--mid-grey, #666)',
        fontSize: 14,
        fontWeight: 600,
        pointerEvents: 'none'
      }}>+852</span>
      <input 
        className="form-input-style" 
        style={{ paddingLeft: 56 }}
        placeholder={placeholder}
        value={localPart}
        onChange={handleChange}
        type="tel"
        required={required}
      />
    </div>
  );
}
